import common from './common';
import system from './system';
import users from './users';
import vehicles from './vehicles';
import access from './access';
import merch from './merch';
import product from './product';
import nfc from './nfc';

const es = {
	common,
	system,
	users,
	vehicles,
	access,
	merch,
	product,
	nfc,
} as const;

export default es;
